import React from 'react';
import styles from '../irlObservations2026.module.css';
import { EditableDueDate, EditablePriority } from '../chrome';
import { DetailHeader, DetailTabs, IrlCounts, MetaPair } from './shared';

export default function IRL_Open({
    request,
    tab,
    onTab,
    onBack,
    onOpenAi,
    onCopy,
    copied,
    tabs,
    onRelatedIrl,
    extraActions,
    onUpdateFields,
    busy,
}) {
    return (
        <>
            <DetailHeader
                kind="irl"
                item={request}
                onBack={onBack}
                onOpenAi={onOpenAi}
                onCopy={onCopy}
                copied={copied}
                extraActions={extraActions}
                onUpdateFields={onUpdateFields}
                busy={busy}
            />
            <DetailTabs tabs={tabs} tab={tab} onTab={onTab} counts={IrlCounts(request)} />
            <div className={styles.detailBody}>
                <div className={styles.detailInner}>
                    <div className={styles.metaGrid}>
                        <MetaPair label="Workstream">{request.workstreamName}</MetaPair>
                        <MetaPair label="Owner">{request.owner}</MetaPair>
                        <MetaPair label="Respondent">{request.respondent}</MetaPair>
                        <MetaPair label="Due date">
                            <EditableDueDate item={request} onSave={onUpdateFields} busy={busy} />
                        </MetaPair>
                        <MetaPair label="Priority">
                            <EditablePriority item={request} onSave={onUpdateFields} busy={busy} />
                        </MetaPair>
                        <MetaPair label="Created">{request.created}</MetaPair>
                    </div>
                    <div className={styles.sectionLabelSm}>Context</div>
                    <div className={`${styles.card} ${styles.cardSpaced}`}>
                        <p className={styles.responseBody}>{request.context}</p>
                    </div>
                    <div className={`${styles.sectionLabelSm} ${styles.sectionGap}`}>Follow-up requests</div>
                    {(request.followUps || []).length === 0 && <p className={styles.emptyBody}>No follow-up requests.</p>}
                    {(request.followUps || []).map(item => (
                        <button key={item.id} type="button" className={styles.relatedCard} onClick={() => onRelatedIrl(item.id)}>
                            <span>
                                <span className={styles.rowId}>{item.id}</span>
                                <span className={styles.rowTitle}>{item.title}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
}
